'use client';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Provider } from 'react-redux';

// eslint-disable-next-line import/extensions

import { store } from './index';

export const ReduxProvider = ({ children }) => <Provider store={store}>{children}</Provider>;
